import React from 'react'
import classNames from 'classnames'

import './InlineGroup.scss'
import { ThemeSpacing } from '../../../types/theme'

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  right?: boolean
  spread?: boolean
  className?: string
  verticalCenter?: boolean
  verticalBottom?: boolean
  verticalTop?: boolean
  block?: boolean
  center?: boolean
  reverse?: boolean
  fullHeight?: boolean
  spaceLeft?: ThemeSpacing
  evenWidthChildren?: boolean
  stretch?: boolean
  'data-test'?: string
}

const InlineGroup = React.forwardRef<HTMLDivElement, Props>(({
  block,
  center,
  children,
  className,
  reverse,
  right,
  spaceLeft,
  spread,
  stretch,
  verticalCenter,
  verticalBottom,
  verticalTop,
  fullHeight,
  evenWidthChildren,
  'data-test': dataTest,
  ...rest
}, ref) => {
  const spaceLeftClass = spaceLeft ? `space-left-${spaceLeft}` : null
  return (
    <div ref={ref} className={classNames('inline-group', {
      'align-center': verticalCenter,
      'align-bottom': verticalBottom,
      'align-top': verticalTop,
      block,
      center,
      evenWidthChildren,
      reverse,
      right,
      spread,
      stretch,
      fullHeight
    }, spaceLeftClass, className)}
    data-test={dataTest}
    {...rest}
    >
      {children}
    </div>
  )
})

export default InlineGroup
